import { render } from "./V4Style.vue?vue&type=template&id=5f8f1944&scoped=true"
import script from "./V4Style.vue?vue&type=script&lang=js"
export * from "./V4Style.vue?vue&type=script&lang=js"

import "./V4Style.vue?vue&type=style&index=0&id=5f8f1944&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8f1944"]])

export default __exports__